export interface User {
  id: number,
  username: string,
  fullName: string,
  role: UserRole,
  password: string,
  account?: Account
}

export interface UserQuery {
  customerNumber?: string
}

export enum UserRole {
  USER = "USER",
  ADMIN = "ADMIN",
  SUPERADMIN = "SUPERADMIN",
  SYSTEM = "SYSTEM"
}

export interface Account {
  id?: number,
  customerName: string,
  email: string,
  customerNumber: string,
  active: boolean,
  city?: string,
  zip?: string,
  phone?: string
  isReturn?: boolean;
  basicConfiguration?: string;
  degree?: number;
  hsa?: number;
  orderNotification?: boolean;
  clientGroups?: string;
  apex?: boolean;
  beta?: boolean;
}

export interface AccountQuery {
  customerNumber?: string
}

export interface AuthState {
  currentUser?: User,
  token?: string,
  isLoggedIn: boolean,
  isRecovering: boolean,
  isSigningIn: boolean
}

export interface LoginData {
  customerNumber?: string,
  username: string,
  password: string,
  rememberMe?: boolean
}

export class LoginResponse {
  constructor(readonly success: boolean,
              readonly user?: User,
              readonly token?: string) {
  }
}

export interface PasswordRecoveryRequest {
  customerNumber: string,
  username: string
}
